import React, { useState } from "react";
import axiosConfig from "../axiosConfig";
import { useHistory } from "react-router-dom";

import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Loading from "../components/Loading/loading";
import Swal from "sweetalert2";

export default function CredentialsForm(props) {
  const [userCredentials, setUserCredentials] = useState([]);
  const [loading, setLoading] = useState(false);

  const open = props.open;

  const handleClose = () => {
    props.close();
  };
  const handlePushVerifiedUser = (verifiedUserId) => {
    props.close(verifiedUserId)
  }

  let history = useHistory();

  const updateField = (e) => {
    setUserCredentials({
      ...userCredentials,
      [e.target.name]: e.target.value,
    });
  };
  const handleClickSubmit = () => {
    let submitForm = props.alertForm;
    axiosConfig
      .post("/User/VerifyUser", {
        email: userCredentials.email,
        password: userCredentials.password,
      })
      .then((res) => {
        switch (props.origin) {
          case "covid":
            submitForm = {
              street: props.alertForm.street,
              number: props.alertForm.number,
              postalcode: props.alertForm.postalcode,
              floor: props.alertForm.floor,
              quarantineDays: props.alertForm.quarantineDays,
              area: props.alertForm.area,
              beneficiaryId: props.alertForm.beneficiaryId,
              municipalityId:props.alertForm.municipalityId,
              latitude:props.alertForm.latitude,
              longitude:props.alertForm.longitude
            };

            axiosConfig
              .post(`/Address/TemporaryAddress`, submitForm)
              .then((res) => {
                if (res.status === 200) {
                  handleClose();
                  props.closeModal();
                  setLoading(false);
                }
              })
              .catch((err) => {
                setLoading(false);
              });
            break;
          case "user":
            axiosConfig
              .post(`/User/CreateUser`, submitForm)
              .then((res) => {
                if (res.status === 200) {
                  Swal.fire("Η καταχώρηση ήταν επιτυχής", "", "success");
                  history.push("/all-users");
                  setLoading(false);
                } else {
                  Swal.fire("Η καταχώρηση ήταν ανεπιτυχής", "", "error");
                  setLoading(false);
                }
              })
              .catch((err) => {
                Swal.fire("Η καταχώρηση ήταν ανεπιτυχής", "", "error");
                setLoading(false);
              });
            break;
          case "covidTracking":
            handlePushVerifiedUser(res.data)
            break;
          case "lastKnownLocation":
            handlePushVerifiedUser(res.data)
            break;
          case "sensitiveData":
            handlePushVerifiedUser(res.data)
            break;
          case "alarmSeverity":
            handlePushVerifiedUser(res.data)
            break;
          default:
            history.push("/");
            break;
        }
      })
      .catch((err) => { });
  };
  if (loading === false) {
    return (
      <div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogContent>
            <DialogContentText>
              Παρακαλώ Εισάγετε τα Στοιχεία Σύνδεσης
            </DialogContentText>
            <TextField
              autoFocus
              InputLabelProps={{
                shrink: true,
              }}
              margin="dense"
              id="email"
              name="email"
              label="Όνομα Χρήστη"
              type="text"
              fullWidth
              onChange={updateField}
            />
            <TextField
              autoFocus
              InputLabelProps={{
                shrink: true,
              }}
              margin="dense"
              id="password"
              name="password"
              label="Κωδικός Χρήστη"
              type="password"
              fullWidth
              onChange={updateField}
            />
          </DialogContent>
          <DialogActions>
            <Button className="CancelButton" onClick={handleClose}>
              Ακυρωση
            </Button>
            <Button
              className="SuccessButton"
              onClick={() => {
                handleClickSubmit();
              }}
            >
              Συνδεση
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  } else {
    return <Loading />;
  }
}
